<template>
  <LayoutContent>
    <AcknowledgementCard :title="`${$t('label.seeYouSoon')}!`">
      <template #acknowledgement-header>
        <p class="secondary--text text--lighten-1 font-weight-medium text-caption">
          {{ $t('label.bookingNo') }}
        </p>
        <p class="font-weight-medium">{{ appointment.booking_number }}</p>
        <div class="d-flex w-100 align-center my-6">
          <div class="wrapping-line" />
          <app-button :label="appointment.status_button" :disabled="isPastAppointment" inactive gradient :secondary="todayAppointment" invert class="px-10 mx-3" />
          <div class="wrapping-line" />
        </div>
      </template>
      <template #acknowledgement-body>
        <v-container class="px-sm-16">
          <v-row>
            <v-col :cols="6">
              <p class="secondary--text text--lighten-1 font-weight-medium text-caption">
                {{ $t('label.dateAndTime') }}
              </p>
              <p class="font-weight-medium">
                <span class="mr-4">{{ appointment.date | shortDate }}</span>
                <span>{{ appointment.time | shortTime }}</span>
              </p>
            </v-col>
            <v-col :cols="6">
              <p class="secondary--text text--lighten-1 font-weight-medium text-caption">
                {{ $t('label.salon') }}
              </p>
              <p class="font-weight-medium">{{ appointment.store }}</p>
            </v-col>
            <v-col :cols="6">
              <p class="secondary--text text--lighten-1 font-weight-medium text-caption">
                {{ $t('label.hairStylist') }}
              </p>
              <p class="font-weight-medium">{{ appointment.stylist }}</p>
            </v-col>
            <v-col :cols="6">
              <p class="secondary--text text--lighten-1 font-weight-medium text-caption">
                {{ $t('label.services') }}
              </p>
              <p class="font-weight-medium" v-for="(service, i) in appointment.services" :key="i">{{ i + 1 }}. {{ service.name }}</p>
            </v-col>
          </v-row>
          <v-divider class="my-4" />
          <p class="font-weight-medium mb-8">{{ appointment.remarks }}</p>
        </v-container>
      </template>
      <template #contact>
        <div class="mb-8">
          <p class="secondary--text text--lighten-1 font-weight-medium text-caption text-center">{{ $t('label.contactUs') }}:</p>
          <p class="secondary--text text--lighten-1 font-weight-medium text-caption text-center">{{ appointment.store_contactno }}</p>
          <a class="font-weight-medium text-caption text-center pa-0" :href="`mailto:${appointment.store_email}`" style="margin-top: -15%">{{ appointment.store_email }}</a>
        </div>
      </template>
      <template #acknowledgement-actions>
        <app-button invert gradient :label="$t('button.backToHome')" :to="{ name: $constants.ROUTE_NAME.HOME }" width="14rem" class="mt-auto" />
        <v-btn
          v-if="!isPastAppointment && !appointment.confirmed_booking"
          outlined
          color="secondary lighten-2"
          width="14rem"
          class="mt-5 rounded-pill text-capitalize"
          :to="{ name: $constants.ROUTE_NAME.APPOINTMENT_EDIT_APPOINTMENT, params: { bookingId: appointment.booking_id } }"
        >
          {{ $t('button.editAppointment') }}
        </v-btn>
        <CancelAppointment
          v-if="!isPastAppointment"
          @successfulCancel="cancelAppointmentSuccess()"
          @failCancel="
            showAppointmentFailedCancelDialog = true
            failedCancelmessage = $event.message
          "
          :bookingId="appointment.booking_id"
        />
      </template>
    </AcknowledgementCard>
    <AppointmentCancelledDialog v-model="showAppointmentCancelDialog" />
    <AppointmentFailedCancelDialog v-model="showAppointmentFailedCancelDialog" :message="failedCancelmessage" />
  </LayoutContent>
</template>

<script>
import LayoutContent from '@/views/layouts/LayoutContent.vue'
import AcknowledgementCard from '@/components/AcknowledgementCard.vue'
import CancelAppointment from '@/components/appointment/CancelAppointment.vue'
import AppointmentCancelledDialog from '@/components/appointment/AppointmentCancelledDialog.vue'
import AppointmentFailedCancelDialog from '@/components/appointment/AppointmentFailedCancelDialog.vue'
import { AppointmentType } from '@/constants/enums'
import { uiHelper } from '@/utils'
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
  name: 'Detail',

  components: {
    LayoutContent,
    AcknowledgementCard,
    CancelAppointment,
    AppointmentCancelledDialog,
    AppointmentFailedCancelDialog
  },

  props: ['id'],

  data() {
    return {
      showAppointmentCancelDialog: false,
      showAppointmentFailedCancelDialog: false,
      failedCancelmessage: '',
      appointmentType: AppointmentType,
      appointment: null
    }
  },
  computed: {
    ...mapState('appointment', ['upcomingAppointments', 'pastAppointments']),
    ...mapGetters('appointment', ['getAppointmentDetail']),
    isPastAppointment() {
      return this.appointment.status_title === 'We shall meet!'
    },
    todayAppointment() {
      return this.appointment.book_date === uiHelper.getTodayDate()
    }
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    ...mapActions('appointment', ['fetchAppointmentDetail']),
    getDetail() {
      this.fetchAppointmentDetail({ booking_id: this.id }).then((res) => {
        this.appointment = res
      })
    },
    cancelAppointmentSuccess() {
      this.getDetail()
      this.showAppointmentCancelDialog = true
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapping-line {
  background-color: var(--v-secondary-lighten4);
  flex-grow: 1;
  flex-shrink: 1;
  height: 1px;

  margin-right: auto;

  &:first {
    margin-left: auto;
    margin-right: unset;
  }
}
</style>
